import React, { useState } from "react";
import useDarkMode from '../../../hooks/useDarkMode';
import "./formInput.css";

const FormInput = ({
  label,
  placeHolder,
  type,
  value,
  width = "",
  onchange,
  readOnly,
  disabled,
  title,
  icon,
  secIcon,
  name,
  step,
  onclick,
  secIconOnClick,
  iconOnClick,
  prepend,
}) => {
  const isDarkMode = useDarkMode();
  const [passwordVisible, setPasswordVisible] = useState(false);

  const isPasswordField = type === "password";
  const inputType = isPasswordField
    ? passwordVisible
      ? "text"
      : "password"
    : type;

  const displayIcon =
    icon ?? (isPasswordField ? (passwordVisible ? "fa-eye-slash" : "fa-eye") : undefined);

  const handleIconClick =
    iconOnClick ??
    (isPasswordField
      ? (e) => {
          e.preventDefault();
          setPasswordVisible((prev) => !prev);
        }
      : undefined);

  const hasToggleIcon = Boolean(displayIcon);

  return (
    <>
      {label && (
        <label
          className="form-label"
          style={{
            color: isDarkMode ? "#ffffff" : "#000000",
          }}
        >
          {label}
        </label>
      )}
      <div className="input-group position-relative">
        {prepend && (
          <span
            className="input-group-text"
            style={{
              borderRadius: "10px 0 0 10px",
              border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
              borderRight: "none",
              background: isDarkMode ? "#2d3436" : "#F9F9F9",
              height: "44px",
              display: "flex",
              alignItems: "center",
              padding: "0 10px",
              color: isDarkMode ? "#ffffff" : "#6c757d",
              fontSize: "16px",
            }}
          >
            {prepend}
          </span>
        )}
        <input
          type={inputType}
          value={value}
          readOnly={readOnly}
          disabled={disabled}
          onChange={onchange}
          onClick={onclick}
          step={step}
          name={name}
          title={title}
          className={`form-control ${isDarkMode ? "dark-mode-input" : "light-mode-input"}`}
          placeholder={placeHolder}
          style={{
            ...getCustomFormStyle(isDarkMode),
            ...{ width: width },
            ...(hasToggleIcon && { paddingRight: secIcon ? "60px" : "40px" }),
            ...(prepend && { borderTopLeftRadius: "0", borderBottomLeftRadius: "0" }),
          }}
        />
        {displayIcon && (
          <button
            type="button"
            className="form-input-password-toggle"
            onClick={handleIconClick}
            tabIndex={-1}
            aria-label={passwordVisible ? "Hide password" : "Show password"}
            style={secIcon ? { right: "35px" } : undefined}
          >
            <i className={`fa ${displayIcon}`} />
          </button>
        )}
        {secIcon && (
          <i
            className={`fa ${secIcon}`}
            onClick={secIconOnClick}
            style={{
              position: "absolute",
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#f03a4f",
              cursor: "pointer",
              zIndex: 2,
            }}
          ></i>
        )}
      </div>
    </>
  );
};

const getCustomFormStyle = (isDarkMode) => ({
  borderRadius: "10px",
  border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
  background: isDarkMode ? "#2d3436" : "#F9F9F9",
  color: isDarkMode ? "#ffffff" : "#000000",
  height: "44px",
  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
});

export default FormInput;
